import { NotificationService } from "./notification.service";
import { Injectable } from "@angular/core";

/** App lvl determines wich class of messages are visible */
export enum DebugLevel {
  TRACE,
  DEBUG,
  INFO,
  ERROR,
  MESSAGE
}
@Injectable({ providedIn: "root" })
export class DebugService {
  private mainPrefix = "@Eurega/";
  /** Actual level of message acces */
  public appLevel: DebugLevel;

  constructor(private notificationsService: NotificationService) { }

  public setDebugLevel(level: DebugLevel) {
    this.appLevel = level;
  }

  public getDebugLevel() {
    return this.appLevel;
  }

  /** Show a message in function of environment acces */
  public debug = (level: DebugLevel, message: string, object: any = null) => {
    if (level >= this.appLevel) {
      switch (level) {
        case 0:
          // TRACE
          console.log(`${this.mainPrefix}TRACEPOINT: ` + message, object);
          break;
        case 1:
          // DEBUG
          console.log(`${this.mainPrefix}DEBUG: ` + message, object);
          break;
        case 2:
          // INFO
          console.warn(`${this.mainPrefix}INFO: ` + message, object);
          break;
        case 3:
          // ERROR
          console.error(`${this.mainPrefix}ERROR: ` + message, object);
          break;
        case 4:
          // MESSAGE, NO CONSOLE LOGS, ONLY MESSAGE BOXES
          this.notificationsService.error(message);
          break;
        default:
          console.log(`${this.mainPrefix}MESSAGE: ` + message, object);
          break;
      }
    }
  };

  /** Sends a notification via popup to user and shows console log for developers */
  public notifyError(trace, description, err) {
    this.debug(DebugLevel.TRACE, trace);
    this.debug(DebugLevel.INFO, err);
    this.notificationsService.error(
      description + " Para mas información consultar la consola."
    );
  }
}
